import {Link, useLocation} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import {useAuth} from '../lib/auth';

interface NavItem {
  path: string;
  key: string;
  icon: string;
}

const navItems: NavItem[] = [
  {path: '/', key: 'nav.dashboard', icon: '◉'},
  {path: '/customers', key: 'nav.customers', icon: '☺'},
  {path: '/servers', key: 'nav.servers', icon: '◫'},
  {path: '/sites', key: 'nav.sites', icon: '◰'},
  {path: '/templates', key: 'nav.templates', icon: '◇'},
];

export default function AppLayout({children}: {children: React.ReactNode}) {
  const {user, logout} = useAuth();
  const location = useLocation();
  const {t} = useTranslation();

  return (
    <div className="app-shell">
      <aside className="sidebar">
        <div className="sidebar-brand">
          {t('app.name')} <span className="accent">{t('app.brand')}</span>
        </div>
        <nav className="sidebar-nav">
          {navItems.map((item) => {
            const isActive =
              item.path === '/'
                ? location.pathname === '/'
                : location.pathname.startsWith(item.path);
            return (
              <Link
                key={item.path}
                to={item.path}
                className={`sidebar-nav-item ${isActive ? 'active' : ''}`}
              >
                <span className="sidebar-nav-icon">{item.icon}</span>
                <span>{t(item.key)}</span>
              </Link>
            );
          })}
        </nav>
        <div className="sidebar-footer">
          {user && (
            <>
              <div className="sidebar-user">{user.name}</div>
              <div className="sidebar-user-email">{user.email}</div>
              <button onClick={logout} className="sidebar-logout">
                {t('logout.button')}
              </button>
            </>
          )}
        </div>
      </aside>
      <main className="app-main">{children}</main>
    </div>
  );
}
